import React, { useState, useEffect, useContext } from 'react';
import NavigationPrompt from 'react-router-navigation-prompt';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import Loader from '../Loader';
import { LocalizationContext } from '../../contexts';
import './index.scss';

const UpdateController = ({ lastEditor = false, lastUpdate = false, hasChanges = false, update = false, children, topTools, sidebarContent }) => {
    const [localization] = useContext(LocalizationContext);

    const [state, _setState] = useState({
        isUpdating: false,
        updateError: false
    });
    const setState = (newState) => {
        _setState({ ...state, ...newState });
    };

    const toggle_onbeforeunload = (on) => {
        window.onbeforeunload = on ? function () { return true; } : false;
    };

    useEffect(() => {
        toggle_onbeforeunload(hasChanges);
    }, [hasChanges]);

    useEffect(() => {

        return () => {
            toggle_onbeforeunload(false);
        };
    }, []);

    const onUpdate = (onConfirm, onCancel) => {
        setState({ isUpdating: true });
        update().then(() => {
            setState({ isUpdating: false });
            if(onConfirm) {
                onConfirm();
            }
        }).catch((error) => {
            setState({ 
                updateError: error && typeof(error) === 'object' && error.dontShowErrorMessage ? false : true, 
                isUpdating: false 
            });
            if(onCancel) {
                onCancel();
            }
        });
    };

    return (
        <div className="update_controller">
            <NavigationPrompt when={hasChanges}>
                {({onConfirm, onCancel}) => (
                    <Dialog onClose={() => {onCancel();}} title={false} >
                        <p>{localization.labels.unsaved_changes.message}</p>
                        <DialogActionsBar>
                            <button className="k-button k-primary" onClick={() => {onUpdate(onConfirm, onCancel);}}>{localization.labels.unsaved_changes.save}</button>
                            <button className="k-button" onClick={() => {onConfirm();}}>{localization.labels.unsaved_changes.continue_without_saving}</button>
                        </DialogActionsBar>
                    </Dialog>
                )}
            </NavigationPrompt>

            {state.isUpdating && <Loader />}
            {state.updateError && <Dialog onClose={() => { setState({ updateError: false }) }} title={localization.labels.save_error_title}>
                <p>{localization.labels.save_error_message}</p></Dialog>}
            <div className="update_controller-container">
                {children}
            </div>
            <div className="update_controller-tools-container">
                <div className="update_controller-top_tools">
                    {topTools}
                    {sidebarContent && (
                        <div className="update_controller-sidebar_content">
                            {sidebarContent}
                        </div>
                    )}
                </div>
                <div className="update_controller-tools">
                    {(lastEditor || lastUpdate) && <hr />}
                    {lastEditor && <><div>{localization.labels.last_editor}</div><div>{lastEditor}</div><hr/></>}
                    {lastUpdate && <><div>{localization.labels.last_publication}</div><div>{lastUpdate}</div><hr/></>}
                    <div>
                        {update && <Button className="update_controller-update_btn" primary={true} disabled={!hasChanges} onClick={() => {onUpdate();}}>{localization.labels.updating}</Button>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateController;